import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../redux/store";
import { fetchUserData } from "../../redux/actions/user.actions";
import ForgotPasswordForm, { ForgotPasswordCopy, forgotPasswordCopy } from "./components/ForgotPasswordForm";
import AuthLayout from "./components/AuthLayout";

const ForgotPasswordPage: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [copy, setCopy] = useState<ForgotPasswordCopy>(() => forgotPasswordCopy("username", "with-username", false));
  const handleCopyChange = useCallback((next: ForgotPasswordCopy) => setCopy(next), []);

  useEffect(() => {
    dispatch(fetchUserData());
  }, [dispatch]);

  return (
    <AuthLayout title={copy.title} subtitle={copy.subtitle}>
      <ForgotPasswordForm onCopyChange={handleCopyChange} />
    </AuthLayout>
  );
};

export default ForgotPasswordPage;
